<script lang="ts" setup>
import type { Component, Ref } from 'vue';
import { ref } from 'vue';
const props = withDefaults(defineProps<{
  title: string,
  resolve: <T>(data: T) => void,
  close: Function,
  modalComponent: Component,
  modalProps: Object,
  lateral?: boolean,
  mdLateral?: boolean,
  width?: string,
  height?: string,
  header?: boolean,
}>(), {
  header: true,
})

const modalData: Ref<{}> = ref({})

function updateModalData(e: any) {
  modalData.value = e
}

// Arma el estilo inline necesario para pisar los min/max-width y min/max-height que define el CSS compartido
function sizeStyle(): Record<string, string> {
  const style: Record<string, string> = {}
  if (props.width) Object.assign(style, { width: props.width, minWidth: props.width, maxWidth: props.width })
  if (props.height) Object.assign(style, { height: props.height, minHeight: props.height, maxHeight: props.height })
  return style
}

</script>
<template>
  <div class="window pmx-col ntn" id="modal-wrapper-window" :class="{ lateral: lateral, mdLateral: mdLateral, 'no-header': !header }" :style="sizeStyle()">
    <div class="header pmx-row pmx-noflex" :class="{ 'header-minimal': !header }">
      <span v-if="header" class="pmx-flx1"> {{ title }} </span>
      <button class="unstyled" @click.prevent="resolve<null>(null)">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>
    <div class="content pmx-flx1 pmx-col">
      <component :is="modalComponent" :data="modalProps" :resolve="resolve" :reject="close"
        @update:modalData="updateModalData"></component>
    </div>
  </div>
</template>
<style lang="less">
@import "../frontend/mobile/themevars.less";

.vfm__content.modalhelper {
  display: grid;
  place-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;


  // Variante de header blanco/texto oscuro con botón de cerrar bordeado, en vez del violeta por default
  // (ver modalCfg.plainHeader en modalHelper.ts). Pensada para modales centrados tipo ExportDataModal.vue.
  &.plain-header .window#modal-wrapper-window .header {
    background-color: white;
    color: #333;
    border-bottom: 1px solid @gray30;

    i {
      color: #333;
    }

    button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border: 1px solid @gray30;
      border-radius: 6px;
    }
  }

  &.lateral {
    place-content: center end;

    .window#modal-wrapper-window {
      height: 100vh;
      max-height: 100vh;
      border-radius: 0;
      background-color: white;

      @media screen and (min-width: 1366px) {
        &.mdLateral {
          width: 35% !important;
        }
      }

      .header {
        height: 100%;
        max-height: 41px;
        border-radius: 0 0 5px 5px;
        padding: 0 21px;
      }

      .content {
        padding: 30px 20px;
      }

      .n-form {
        padding: initial;
      }

      .n-form-item-label__text {
        font-size: 13px;
      }

      .footer {
        padding: 0px;
      }
    }
  }

  .window#modal-wrapper-window {
    min-width: 25vw;
    width: 30vw;
    height: auto;
    max-height: 90vh;
    background-color: white;
    border-radius: 8px;

    @media screen {
      @media (max-width: 768px) {
        width: 100vw;
      }

      @media (min-width: 769px) and (max-width: 992px) {
        width: 80vw;
      }
    }

    .header {
      min-height: 20px;
      background-color: @primaryColor;
      align-items: center;
      color: white;
      padding: 1em;

      i {
        color: white;
      }

      &.header-minimal {
        background-color: transparent;
        justify-content: flex-end;
        padding: 0.77em 0.77em 0;

        i {
          color: #757575;
        }
      }
    }

    &.no-header .content {
      padding: 0.77em 1.54em 1.54em;
    }

    .footer {
      gap: 11px;
      justify-content: flex-end;
    }
  }
}
</style>